export const PASSWORD = 'password';